import { $$ } from '../lib/domUtils';

const banners = $$('.js-banner');

// Glide is the single biggest thing in the bundle, and only the homepage and the
// opportunities block ever use it, so it is pulled in as its own chunk and only
// when there is actually something to mount. Its stylesheet is compiled into
// main.css either way, so the slides are laid out before this resolves.
if (banners.length) {
  import('@glidejs/glide').then(({ default: Glide }) => {
    banners.forEach(banner => {
      new Glide(banner, {
        type: 'carousel',
        focusAt: 'center',
        gap: 100,
        autoplay: 6000,
        animationDuration: 1000,
        animationTimingFunc: 'cubic-bezier(0.13, -0.01, 0.16, 1)',
      }).mount();
    });
  });
}
